import { inject, Injectable } from '@angular/core';
import { ApiResponse } from '../interfaces/api-response.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ChatbotRequest, ChatbotResponse } from '../interfaces/chatbot.model';

/**
 * 企業方案比較服務
 */
@Injectable({
  providedIn: 'root',
})
export class ChatbotService {

    http: HttpClient = inject(HttpClient);
    
  /**
   * CB-094 發送生成 AI 回覆的任務
   * @param request 任務請求
   */
  aiChatbot (
    request: ChatbotRequest
  ): Observable<ApiResponse<ChatbotResponse>> {
    return this.http.post<ApiResponse<ChatbotResponse>>(
      API_ENDPOINTS.AI_CHATBOT,
      request
    );
  }
}
